import React, {Component, useEffect, useState} from 'react';
import './styles.scss';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppParagraph from '../../../../components/app-paragraph';
import {strings} from '../../../../util/strings';
import ModalTemplate from '../../../../components/modal';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import AppButton from '../../../../components/app-button';

interface AppointmentsLegalInfoModalProps {
  show: boolean;
  setShowModal(value: any): void;
  labels: typeof strings.pt.appointments;
}

function AppointmentsLegalInfoModal({
  show,
  setShowModal,
  labels,
}: AppointmentsLegalInfoModalProps) {
  return (
    <div className="myProfilePopup-modal-content p-0">
      <ModalTemplate
        className="myProfilePopup-modal"
        show={show}
        onHide={() => setShowModal(false)}
        cross={true}
        hideFooter={true}>
        <Column className="myProfilePopup-column">
          <Row className="myProfilePopup-title-row">
            <p
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="p-myProfilePopup">
              {labels?.appointments_legalinfo_title}
            </p>
          </Row>
          <Row className="myProfilePopup-paragraph">
            <Column>
              <Row className="myProfile-text-row">
                <AppParagraph
                  className="paragraph-text"
                  style={{...fonts.MM}}
                  label={labels?.appointments_legalinfo_text}
                />
              </Row>
            </Column>
          </Row>
          <Row className="myProfilePopup-button">
            <AppButton
              onClick={() => setShowModal(false)}
              variant="inverted"
              className="legal-info-confirm">
              {labels?.appointments_legalinfo_confirm}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.appointments,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentsLegalInfoModal)
);
